module.exports = __webpack_public_path__ + "static/media/1-1.80d5e947.jpg";